<template>
  <div class="bg">
    <div class="userBox">
      <el-card shadow="always">
        <div>
          <p>
            <span>{{ form.name }}</span>
          </p>
          <p>
            <span>{{ form.roleName }}</span>
          </p>
        </div>
        <div>
          <el-image style="width: 80px; height: 80px" :src="form.url" fit="contain">
          </el-image>
          <!-- <img :src="form.url" alt="" /> -->
        </div>
      </el-card>
      <router-link :to="{ path: '/user/personInfo' }" tag="p">
        <el-card shadow="always">
          <span>
            <i class="iconfont icon-gerenxinxi" />
            个人信息
          </span>
          <i class="el-icon-arrow-right" />
        </el-card>
      </router-link>
      <router-link :to="{ path: '/user/modifyPassword' }" tag="p">
        <el-card shadow="always">
          <span>
            <i class="iconfont icon-zu" />
            修改密码
          </span>
          <i class="el-icon-arrow-right" />
        </el-card>
      </router-link>

      <div class="quit">
        <button @click="quit({ type: 'session' })">退出账户</button>
      </div>
    </div>
  </div>
</template>
<script>
import { getDetail } from "@/api/user/index";
import { resetRouter } from "@/router/index";
import { clearStore } from "@/utils/storage";

export default {
  data() {
    return {
      form: {},
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  created() {
    this.info();
  },
  methods: {
    info() {
      getDetail().then((res) => {
        this.form = res.data;
      });
    },
    quit(params = {}) {
      this.$dialog
        .confirm({
          title: "退出登录",
          message: "确定退出登录",
        })
        .then(() => {
          clearStore(params);
          if (this.$store.state.app.item !== undefined) {
            this.$store.commit("Item", "");
          }
          this.$store.commit("ProjectId", "");
          this.$store.dispatch("logout");
          // 清空动态创建的路由
          // resetRouter();
          this.$router.push("/");
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  margin-bottom: 40px;
  min-height: 100vh;
  background-color: #f0f0f0;
  padding-top: 5px;
}
a {
  text-decoration: none;
}
.headerText {
  button {
    width: 100%;
    border: none;
    color: #fff;
    font-size: 16px;
    background-color: #1564c3;
  }
}
.userBox {
  margin: 10px;
  .el-card {
    margin-bottom: 10px;
  }
  /deep/ .el-card__body {
    display: flex;
    align-items: center;
    span {
      font-size: 14px;
    }
    i {
      white-space: nowrap;
      font-size: 20px;
      color: #1564c3;
      margin-right: 5px;
    }
    justify-content: space-between;
    div:nth-child(1) {
      p:nth-child(1) {
        span {
          font-size: 18px;
        }
        margin-bottom: 5px;
      }
      p:nth-child(2) {
        color: #95a5a6;
      }
    }
    div:nth-child(2) {
      margin-right: 20px;
    }
  }
  .quit {
    button {
      width: 100%;
      height: 40px;
      border: none;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      border-radius: 4px;
      background-color: #1564c3;
    }
  }
}
</style>
